<template>
  <div>
    <el-input-number
      :disabled="item.disabled"
      :value="value"
      :controls-position="item.cposition?item.cposition:'right'"
      :placeholder="item.placeholder"
      :min="item.min ? item.min : -100"
      :max="item.max ? item.max : 100"
      clearable
      @change="change($event)"
      @input="change($event)"
      class="sr-number"
      v-bind="item"
    ></el-input-number>
  </div>
</template>

<!--
  功能：功能描述
  汪振涛
  时间：2020年11月19日 16:56:33
  版本：v1.0
-->
<script>
export default {
  name: "SrNumber",
  model: {
    prop: "value",
    event: "change",
  },

  props: {
    value: String | Number,
    item: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {};
  },
  methods: {
    change(val) {
      this.$emit("change", val);
    },
  },
};
</script>




// WEBPACK FOOTER //
// packages/SrNumber/SrNumber.vue